import "react-datepicker/dist/react-datepicker.css";

import ru from "date-fns/locale/ru";
import { forwardRef, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";

import Icon from "@/components/common/icon";
import Input from "@/components/common/input";
import { setParam } from "@/redux/action-creaters/cart";
import { getDateString } from "@/utils";
import { UserFields } from "~/types/cart";

import styles from "./index.module.scss";

const CustomInput = forwardRef(({ value, onClick }: any, ref) => (
  <Input
    value={value}
    onClick={onClick}
    ref={ref}
    right={
      <span className={styles.Icon}>
        <Icon id="data" width={20} height={20} />
      </span>
    }
  />
));

CustomInput.displayName = "CustomInput";

export default function InstalTime() {
  const { params, isParamsLoaded } = useSelector((state: any) => state.cart);
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState("");
  const [loaded, setLoaded] = useState(false);

  const pointId = useMemo(() => {
    return params[UserFields.pointId] ?? null;
  }, [params]);

  const options = useMemo(() => {
    const hour = new Date().getHours();
    let i = 9;
    // eslint-disable-next-line eqeqeq
    if (getDateString(date) == getDateString(new Date())) {
      if (hour < 20) {
        i = hour + 1;
      }
    }
    const hours = [];
    while (i <= 20) {
      hours.push(i);
      // eslint-disable-next-line no-plusplus
      i++;
    }
    return hours;
  }, [date]);

  useEffect(() => {
    if (params[UserFields.installTime] && !loaded) {
      const date = JSON.parse(params[UserFields.installTime]);
      setDate(new Date(date.date));
      setTime(date.time);
      setLoaded(true);
    }
  }, [params]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (isParamsLoaded) {
      dispatch(
        setParam({
          ...params,
          [UserFields.installTime]: JSON.stringify({ date, time }),
        }),
      );
    }
  }, [date, time, isParamsLoaded]);

  const minDate = useMemo(() => {
    const minDays = params[UserFields.deliveryDays] ?? 0;
    return new Date(Date.now() + minDays * 24 * 60 * 60 * 1000);
  }, [params]);

  useEffect(() => {
    const minDateNum = `${minDate.getFullYear()}${minDate.getMonth()}${minDate.getDate()}`;
    const currentDateNum = `${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
    if (minDateNum > currentDateNum) {
      setDate(minDate);
    }
  }, [minDate, date]);

  return (
    pointId && (
      <div>
        <span className={styles.Title}>
          Выберите желаемую дату и время установки:
        </span>
        <div className={styles.Inputs}>
          <div className={styles.Date}>
            <DatePicker
              selected={date}
              dateFormat="dd-MM-yyyy"
              locale={ru}
              minDate={minDate}
              onChange={(date: any) => setDate(date)}
              customInput={<CustomInput />}
            />
          </div>
          <select
            onChange={(event) => setTime(event.target.value)}
            value={time}
          >
            {options.map((option) => (
              <option key={option}>{option}:00</option>
            ))}
          </select>
        </div>
        <div className="text">
          <div className="block-attention">
            Работы по установке выбранного Вами товара и стоимость такой
            установки не входят в заказ. После оформления заказа, мы свяжемся с
            Вами и проконсультируем по стоимости и возможному времени установки.
          </div>
        </div>
      </div>
    )
  );
}
